class ProductModal extends ModalDialog {
  constructor() {
    super();
    this.body = this.querySelector('[data-modal-body]');
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    const activeMediaId = this.openedBy.getAttribute('data-media-id');

    this.querySelector(
      `[data-media-id="${activeMediaId}"]`,
    ).parentElement.classList.remove('hidden');

    this.body.scrollTop = this.querySelector(
      `[data-media-id="${activeMediaId}"]`,
    ).offsetTop;
  }
}

customElements.define('product-modal', ProductModal);
